import React from "react";

const Home = () => {
  return (
    <section>
      <div className="container">
        <h1 className="name">
          <span className="logo-emoji">🐈</span>
          <p className="welcome"> Welcome To Your Lovely Cats App</p>
          <span className="logo-emoji">🐈</span>
        </h1>
      </div>
    </section>
  );
};

export default Home;
